import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, ContactModel, EntityModel, ResponseDeleteModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IContactsService {
    getContacts(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    getContactGroups(req: GridRequestModel): ng.IPromise<GridModel>
    createContact(req): ng.IPromise<ContactModel>
    getContact(id, state?: any): ng.IPromise<ContactModel>
    deleteContact(id): ng.IPromise<ResponseDeleteModel>
}

export class ContactsService implements IContactsService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getContacts(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.contacts.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getContactGroups(req: GridRequestModel): ng.IPromise<GridModel> {
        var getContactGroups: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.contacts['getContactGroups']
        return getContactGroups({ request: req }).$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
    
    getContact(id, state: any = {}) {
        var get = this.apiResource.contacts.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    createContact(req): ng.IPromise<ContactModel> {
        return this.apiResource.contacts.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    deleteContact(id): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.contacts.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
}
